import { render, staticRenderFns } from "./crm-create-guest-coming-reason.vue?vue&type=template&id=48dc5cf8&"
import script from "./crm-create-guest-coming-reason.vue?vue&type=script&lang=js&"
export * from "./crm-create-guest-coming-reason.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports